import React, {useEffect, useState} from "react";
import {useFunnel} from "../../../context/FunnelContext";
import {useFunnelNavigation} from "../../../hooks/useFunnelNavigation";

export function FinalSplash() {
    const {state} = useFunnel();
    const {nextStep} = useFunnelNavigation();
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [showText, setShowText] = useState(true);

    // Calculate weight difference
    const calculateWeightDifference = () => {
        if (!state.userData.weight || !state.userData.weightGoal) return null;

        let currentWeight =
            state.userData.weight.unit === "imperial"
                ? Number(state.userData.weight.weight)
                : Number(state.userData.weight.weight);

        let targetWeight =
            state.userData.weightGoal.unit === "imperial"
                ? Number(state.userData.weightGoal.weight)
                : Number(state.userData.weightGoal.weight);

        return Math.abs(currentWeight - targetWeight).toFixed(1);
    };

    // Calculate target date (3 months from now)
    const targetDate = new Date();
    targetDate.setMonth(targetDate.getMonth() + 3);
    const formattedDate = targetDate.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
    });

    const textSequence = [
        "Welcome to Caloria! 👋",
        "Based on your answers...",
        `We've created a plan to help you lose ${calculateWeightDifference()} kg by ${formattedDate}`,
        "And build healthy habits that last 💪",
        "Let's get started!",
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            if (currentTextIndex < textSequence.length - 1) {
                setShowText(false);
                setTimeout(() => {
                    setCurrentTextIndex((prev) => prev + 1);
                    setShowText(true);
                }, 500);
            } else {
                // When all text has been shown, wait and proceed to next step
                setTimeout(() => {
                    nextStep();
                }, 3000);
            }
        }, 3000);

        return () => clearTimeout(timer);
    }, [currentTextIndex, nextStep, textSequence.length]); // Added textSequence.length to dependencies

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-6">
            <div className="text-center">
                {currentTextIndex === 0 && (
                    <div
                        className={`mb-6 ${
                            showText ? "opacity-100" : "opacity-0"
                        } transition-opacity duration-500`}
                    >
                        <img
                            src="/app_icon.png"
                            alt="Caloria Logo"
                            className="w-20 h-20 mx-auto"
                        />
                    </div>
                )}
                <div
                    className={`transition-all duration-500 transform ${
                        showText ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                    }`}
                >
                    <h1 className="text-3xl font-bold text-gray-900 mb-4">
                        {textSequence[currentTextIndex]}
                    </h1>
                </div>
            </div>
        </div>
    );
}